import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import "../../assets/css/agent/user-emails.scss";
import FeaturesTab from "../../components/FeaturesTab";
import { AiOutlineReload, AiOutlineDown } from "react-icons/ai";
import RightBar from "../../components/RightBar";
import axiosInstance from "../../environment/axiosInstance";
import { useParams } from "react-router-dom";
import ReactPaginate from 'react-paginate';
import "../../assets/css/pagination.scss";
import moment from "moment";

function UserEmails() {
    const { userId } = useParams();
    const history = useHistory();
    const [opened_tab, setOpenedTab] = useState(null);
    const [email_tickets, setEmailTickets] = useState([]);
    const [emailTicketsCount, setEmailTicketsCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [checkboxDropdownOpen, setCheckboxDropdownOpen] = useState(false);

    const useQuery = () => {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let searchParams = useQuery();

    useEffect(() => {
        let page = 1;

        if (searchParams.get("page")) {
            page = searchParams.get("page");
        }

        setPage(page);
        fetchTickets(page);
    }, [searchParams.get("page")]);

    useEffect(() => {
        var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));
        setOpenedTab(user_tabs.filter(tab => tab.id == userId)[0]);
    }, [userId]);

    const fetchTickets = (page) => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/recentemails/" + userId + "?page=" + page)
            .then(response => {
                if (response.data) {
                    setEmailTickets(response.data.Data.docs);
                    setEmailTicketsCount(response.data.Data.totalDocs);
                    setTotalPages(response.data.Data.totalPages);
                }
            });
    }

    const handlePageClick = (event) => {
        history.push("/emails/" + userId + "?page=" + (event.selected + 1));
    }

    return (
        <div>
            {/* <Header />
            <UsersTabs /> */}
            <div className="user-emails row m-0">
                {/* <div
                    className="p-0 left-col"
                    style={{
                        borderRight: "1px solid #D9D9D9"
                    }}
                >
                    <LeftBar />
                </div> */}
                <div className="p-0 center-col">
                    <FeaturesTab />
                    <div className="emails-content">
                        <div className="top-bar row m-0">
                            <div className="col-6 p-0 d-flex align-items-center left">
                                {/* <div className="d-flex align-items-center cursor-pointer">
                                    <input type="checkbox" />
                                    <AiOutlineDown
                                        size={16}
                                        className="ms-1"
                                        onClick={() => setCheckboxDropdownOpen(!checkboxDropdownOpen)}
                                    />
                                </div>
                                {
                                    checkboxDropdownOpen ?
                                        <div className="dropdown-menu">
                                            <p className="m-0 menu-item">All</p>
                                            <p className="m-0 menu-item">Read</p>
                                            <p className="m-0 menu-item">Unread</p>
                                        </div>
                                        :
                                        <></>
                                } */}
                                <p className="m-0 title">Emails with <span>{opened_tab?.name}</span></p>
                            </div>
                            <div className="col-6 p-0 d-flex align-items-center justify-content-end">
                                <input type="text" className="form-control search-input" placeholder="Search here..." />
                                {/* <input type="date" className="form-control date-input" /> */}
                                <AiOutlineReload
                                    size={20}
                                    color="#999999"
                                    className="ms-1 cursor-pointer"
                                />
                            </div>
                        </div>
                        <div className="emails-section">
                            {
                                email_tickets?.map(email => {
                                    return (
                                        <Link
                                            to={"/ticket/emails/" + userId + "?ticket_id=" + email.ticket_id?._id}
                                        >
                                            <div className="email-row row m-0">
                                                <div className="col-3 p-0 d-flex align-items-center">
                                                    <input type="checkbox" />
                                                    <p className="m-0 user-name">&nbsp;{email.ticket_id?.customer_name}</p>
                                                </div>
                                                <div className="col-7 p-0">
                                                    <p className="m-0 email-text">{email.plain_body}</p>
                                                </div>
                                                <div className="col-2 p-0 text-right">
                                                    <p className="m-0 date-time">{moment(email.createdAt).format('DD-MM-YYYY hh:mm:ss a')}</p>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })
                            }
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel=">"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={totalPages}
                                previousLabel="<"
                                renderOnZeroPageCount={null}
                                className="pagination"
                                activeClassName="active-page"
                                forcePage={page - 1}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className="p-0 right-col"
                    style={{
                        borderLeft: "1px solid #D9D9D9"
                    }}
                >
                    <RightBar />
                </div>
            </div>
        </div>
    )
}

export default UserEmails;